import { render } from "./treeNode.vue?vue&type=template&id=2265d144"
import script from "./treeNode.vue?vue&type=script&lang=js"
export * from "./treeNode.vue?vue&type=script&lang=js"

import "./treeNode.vue?vue&type=style&index=0&id=2265d144&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__